<div class="container sac-flow-wrapper" *ngIf="!isMobile">
  <div class="heading">
    <h2>Start a Fundraiser in three simple steps</h2>
  </div>
  <div class="row">
    <div class="col-md-6 contents">
      <div class="row">
        <div class="col-md-2">
          <img loading="lazy" data-src="/assets/images/homepage/sac-separator.png" class="separator" height="450" width="64" alt="Start a Fundraiser Separator" />
        </div>
        <div class="col-md-10">
          <div class="flow-wrapper">
            <div class="start-fr">
              <span class="sub-heading">Start your fundraiser</span>
              <span class="descr">It’ll take only 2 minutes. Just tell us a few details about you and the ones you are
                raising funds for.</span>
            </div>
            <div class="share-fr">
              <span class="sub-heading">Share your fundraiser</span>
              <span class="descr">All you need to do is share the fundraiser with your friends and family. In no time,
                support will start pouring in.</span>
              <span class="sub-desc">
                Share your fundraiser directly from dashboard on social media.
              </span>
            </div>
            <div class="withdrw-funds" inViewport (inViewportAction)="playVideo($event)">
              <span class="sub-heading">Withdraw Funds</span>
              <span class="descr">The funds raised can be withdrawn without any hassle directly to your bank
                account.</span>
              <span class="sub-desc">
                It takes only 5 minutes to withdraw funds on ketto.
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-md-6 video-section">
      <img loading="lazy" data-src="/assets/images/defaultBlurImg.png" width="311" height="615" [hidden]="!imgLoader" alt="Default image" />
      <video width="311" muted loop #videoPlayer>
        <source src="/assets/videos/screen_recording.webm" type="video/webm">
        <source src="/assets/videos/screen_recording.mp4" type="video/mp4">
        <p>Your browser doesn't support HTML5 video. Here is
          a <a href="https://d1vdjc70h9nzd9.cloudfront.net/videos/screen_recording.webm">link to the video</a> instead.
        </p>
      </video>
    </div>
    <div class="row call-to-action text-center">
        <app-startfundraiser-button label="START A FUNDRAISER FOR FREE" pageName="home" info2="home_2" [width]="isMobile ? '100%' : '290px'" height="51px"></app-startfundraiser-button>
        <app-talk-to-us-btn info2="home_1" [width]="isMobile ? '100%' : '290px'" height="50px"></app-talk-to-us-btn>
        <!-- <app-button btnClass="ketto-outline-btn" label="Know your Treatment Cost" (click)="routeTo('new/cost-calculator')"></app-button> -->
    </div>
  </div>
  <div class="chat-with-us">
    <app-chat-with-us [html]="'Have any questions for us? Chat with our team on Facebook or WhatsApp now.'" fbposition='3' whatsposition='3' pageName='crowdfunding' [hidden]="isMobile"></app-chat-with-us>
  </div>

  <!-- <div class="row container "> -->
 <!-- <app-whatsapp-msg html="Have any questions for us? Chat with our team on WhatsApp Now" label="Chat (+91 9930088522)" btnClass="whatsapp-b" info2="8"></app-whatsapp-msg> -->
    <!-- </div> -->
</div>

<div class="container sac-flow-wrapper-mobile" *ngIf="isMobile">
  <div class="sub-title">
    Start a Fundraiser in three simple steps
  </div>
  <div class="mobile-wrapper">
    <img loading="lazy" data-src="/assets/images/homepage/sac-separator.png" class="separator" alt="Start a Fundraiser Separator" />
    <div class="flow-wrapper">
      <div class="title">Start your fundraiser</div>
      <div class="subtitle">It’ll take only 2 minutes. Just tell us a few details about you and the ones you are raising funds for.</div>
      <div class="title">Share your fundraiser</div>
      <div class="subtitle">All you need to do is share the campaign with your friends and family. In no time, support will start pouring in.</div>
      <span class="sub-desc">
        Share your fundraiser directly from dashboard on social media.
      </span>
      <div class="title">Withdraw Funds</div>
      <div class="subtitle">The funds raised can be withdrawn without any hassle directly to your bank account.</div>
      <span class="sub-desc">
        It takes only 5 minutes to withdraw funds on ketto.
      </span>
    </div>
  </div>
  <div class="row call-to-action">
    <app-startfundraiser-button label="START A FUNDRAISER" pageName="home" info2="home_2" [width]="isMobile ? '100%' : '290px'" height="51px"></app-startfundraiser-button>
    <app-talk-to-us-btn info2="home_1" [width]="isMobile ? '100%' : '290px'" height="50px"></app-talk-to-us-btn>
    <!-- <app-button btnClass="ketto-outline-btn" label="Know your Treatment Cost" (click)="routeTo('new/cost-calculator')"></app-button> -->
  </div>
</div>
